import * as React from "react";
import { IInfoTipProps } from "./tool-tip.d";
import ReactTooltip from "react-tooltip";
import { Info } from "@material-ui/icons";
import { infoTip } from "./tool-tip.styles";

export class InfoTip extends React.PureComponent<IInfoTipProps, {}> {
  private maybeOpenLink = () => {
    if (this.props.href) {
      window.open(this.props.href, "_blank");
    }
  };

  public render() {
    const {
      text,
      iconStyle,
      maxWidth,
      position,
      targetElement,
      href,
      targetElementContainerStyles,
    } = this.props;
    const iconStyles = { ...infoTip, ...iconStyle, cursor: !!href ? "pointer" : "default" };
    const tipText = typeof text === "string" ? <span>{text}</span> : text;
    const id = Math.random().toString(36).substring(2);
    return (
      <span>
        {!!targetElement ? (
          <div
            data-tip
            data-for={id}
            onClick={this.maybeOpenLink}
            style={targetElementContainerStyles}
          >
            {targetElement}
          </div>
        ) : (
          <Info data-tip data-for={id} style={iconStyles} onClick={this.maybeOpenLink} />
        )}
        <ReactTooltip id={id} effect="solid" place={position} multiline type="dark">
          <div style={{ maxWidth, lineHeight: 1.2, padding: "5px 2px" }}>{tipText}</div>
        </ReactTooltip>
      </span>
    );
  }
}
